import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import TaskCard from "../components/TaskCard";
import { Inbox } from "lucide-react";

export default function MyTasks() {
  const [posted, setPosted] = useState([]);
  const [claimed, setClaimed] = useState([]);
  const [tab, setTab] = useState("claimed");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/tasks/mine").then(({ data }) => {
      setPosted(data.posted || []);
      setClaimed(data.claimed || []);
    }).finally(() => setLoading(false));
  }, []);

  const list = tab === "claimed" ? claimed : posted;

  return (
    <div className="space-y-6" data-testid="my-tasks-page">
      <div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight">My tasks.</h1>
        <p className="text-[var(--cs-ink-2)] mt-1">Tasks you've claimed and tasks you've posted.</p>
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => setTab("claimed")}
          data-testid="tab-claimed"
          className={`brut-btn ${tab === "claimed" ? "brut-btn-money" : ""}`}
        >
          Claimed ({claimed.length})
        </button>
        <button
          onClick={() => setTab("posted")}
          data-testid="tab-posted"
          className={`brut-btn ${tab === "posted" ? "brut-btn-money" : ""}`}
        >
          Posted ({posted.length})
        </button>
      </div>

      {loading ? (
        <div className="text-center py-12 text-[var(--cs-ink-2)] font-bold uppercase tracking-widest text-sm">Loading…</div>
      ) : list.length === 0 ? (
        <div className="brut-card p-10 text-center">
          <Inbox className="mx-auto text-[var(--cs-ink-2)]" size={32} />
          <div className="font-display text-2xl font-extrabold mt-3">Nothing here yet.</div>
          <p className="text-[var(--cs-ink-2)] mt-1">
            {tab === "claimed" ? "Claim a task from Browse to see it here." : "Post your first task to get started."}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((t, i) => (
            <TaskCard key={t.id} task={t} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
